// Čist modul (ide i u klijentski bundle): provjera broja telefona. Broj se
// sprema onako kako je upisan (samo trimovan), provjerava se samo da liči na
// telefon: opcionalni "+" ili "00" na početku, pa 6 do 15 cifara, uz razmake,
// crtice, kose crte, tačke i zagrade kao separatore.

const PHONE_SEPARATORS = /[\s\-/.()]+/g;
const PHONE_DIGITS_RE = /^\+?\d{6,15}$/;

export const PHONE_ERROR = "Unesi ispravan broj telefona, npr. +387 61 234 567";

export function isValidPhone(raw: string): boolean {
  return PHONE_DIGITS_RE.test(raw.trim().replace(PHONE_SEPARATORS, ""));
}
